import React from "react";

type Props = {};

const PreviewIcon = (props: Props) => {
  return (
    <div>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.8423 2H14.0002V5.15789"
          stroke="#F1F3F5"
          strokeWidth="2.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.3684 8.94737V12.7368C13.3684 13.4345 12.8029 14 12.1053 14H3.26316C2.56553 14 2 13.4345 2 12.7368V3.89473C2 3.19711 2.56553 2.63158 3.26316 2.63158H7.05263"
          stroke="#F1F3F5"
          strokeWidth="2.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.31567 7.68423L13.6841 2.31581"
          stroke="#F1F3F5"
          strokeWidth="2.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default PreviewIcon;
